import {store} from "../index";
import {SIZE_OF_CELL} from "../constants/constants";
import {sleeveSize} from "../constants/constants";

export const isAllowSleeve = () => {
    const  sides = store.getState().buildValuesSides,
        height = store.getState().buildValues.height;
    for(let i = 0; i < sides.length; i++){
        for(let j = 0; j < sides[i].sleeves.length; j++){
            if(Math.round(sides[i].sleeves[j].top + sleeveSize[sides[i].sleeves[j].background]/2) <= SIZE_OF_CELL){
                return false;
            }
        }
    }
    return true;
};


// WEBPACK FOOTER //
// ./src/helpers/isAllowSleeves.js